export const agentQueryKeys = {
    pageAll: () => ["page-agents"],
    recent: () => ["agent", "recent"],
    read: (agentId: number) => ["agent", agentId]
} as const;
